import React, { Fragment, useEffect } from "react";
import Router from "./routers/router";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { resetAllMessage } from "./redux";
import { getGymProfile } from "./services/gymService";
import { LocalStorageKeys } from "./core";

const App = () => {
  const { hasError, hasNotification, hasSuccess, hasWarning, message } =
    useSelector((state) => state.notification);
  const { gym, isLoggedIn } = useSelector((state) => state.gym);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoggedIn && !gym) {
      getGymProfile();
    } 
     if (!isLoggedIn) {
      localStorage.removeItem(LocalStorageKeys.gymToken);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (hasNotification && message.length > 0) {
      toast.info(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      dispatch(resetAllMessage());
    }
    if (hasWarning && message.length > 0) {
      toast.warn(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      dispatch(resetAllMessage());
    }
    if (hasError && message.length > 0) {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      dispatch(resetAllMessage());
    }
    if (hasSuccess && message.length > 0) {
      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      dispatch(resetAllMessage());
    }
  }, [hasError, hasNotification, hasSuccess, hasWarning, message, dispatch]);

  return (
    <Fragment>
      <ToastContainer />
      <Router />
    </Fragment>
  );
};

export default App;
